import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ArrowLeft } from '@components/Common/Icons';
import { Cross, ArrowLeft3 } from '@lion-design/icons';
import BottomSlide from './subComponents/BottomSlide';
import ContentBlock from './subComponents/ContentBlock';
import styles from './styles.module.scss';
import cN from 'classnames';

interface I_SlidePage {
    visible: boolean;
    setIsVisible: (visible: boolean) => void;
    title: string;
    children: JSX.Element;
    isHeaderShow?: boolean;
    side?: string;
}

const SlidePage: React.FC<I_SlidePage> = ({
    visible,
    children,
    title,
    setIsVisible,
    isHeaderShow = true,
    side,
}) => {
    useEffect(() => {
        const body = document.querySelector('body');
        const html = document.querySelector('html');
        if (!body || !html) return;
        if (visible) {
            html.style.overflow = 'hidden';
            body.style.overflow = 'hidden';
        } else {
            html.style.overflow = '';
            body.style.overflow = '';
        }
    }, [visible]);

    return (
        <BottomSlide side={side}>
            <ContentBlock
                visible={visible}
                setIsVisible={setIsVisible}
                title={title}
                isHeaderShow={isHeaderShow}
                side={side}
            >
                {children}
            </ContentBlock>
        </BottomSlide>
    );
};

export default SlidePage;
